// extracted by mini-css-extract-plugin
export default {"NoGames":"GameScheduleContent_NoGames__klsLP"};